import React from "react";
import { Reveal } from "./Reveal";
import { CheckIcon } from "lucide-react";
const items = ["Quieres crear tu propia línea de sales de baño.", "Empiezas completamente desde cero.", "Buscas una guía paso a paso.", "Quieres evitar errores y ahorrar tiempo.", "Sueñas con tener una marca propia.", "Quieres lanzar una colección con apariencia profesional."];
export function ForYou() {
  return <section className="w-full bg-[#fbf5f0] px-5 py-14" data-id="element-87" data-mp="3qnsmbd64vsal">
      <div className="mx-auto max-w-xl" data-id="element-88" data-mp="3lpr0ikhbpevf">
        <Reveal className="text-center" data-id="element-89" data-mp="3lopghqibxi1k">
          <h2 className="font-serif-display text-2xl font-semibold text-[#3d2b30] sm:text-3xl" data-id="element-90" data-mp="3ls4ueq09ol1e">
            🌸 Este Kit es para ti si…
          </h2>
        </Reveal>

        <Reveal delay={0.05} className="mt-8" data-id="element-91" data-mp="3vp9g6oq7aeho">
          <ul className="space-y-3" data-id="element-92" data-mp="25binphmcujwz">
            {items.map(item => <li key={item} className="flex items-start gap-3 rounded-2xl border border-[#e7d3d8] bg-white p-4 text-sm font-semibold text-[#3d2b30]" data-id="element-93" data-mp="25dlg28azcp4v">
                <span className="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-[#a04a63]" data-id="element-94" data-mp="345w0sakw7c9o">
                  <CheckIcon className="h-3 w-3 text-white" data-id="element-95" data-mp="3e64xdpisqzpl" />
                </span>
                {item}
              </li>)}
          </ul>
        </Reveal>
      </div>
    </section>;
}